export default __webpack_public_path__ + "static/media/img6.c4bd7d21.jpg";